import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BASE}/api`, timeout: 10000 });

const MOCK_SERVICES = {
  dental: [
    { id: "comprehensive", name: "Comprehensive dental care", icon: "shield", desc: "Cleanings, fillings, crowns and bridges — every treatment carefully shaped to fit you." },
    { id: "family", name: "For the whole family", icon: "heart", desc: "From your child's first tooth to lifelong adult care, we welcome every generation." },
    { id: "cosmetic", name: "Cosmetic & whitening", icon: "sparkles", desc: "Veneers, bonding and whitening to bring your most confident smile forward." },
    { id: "tech", name: "Modern technology", icon: "grid", desc: "Digital X-rays, intra-oral scanning and laser dentistry — gentler, faster, clearer." },
    { id: "calm", name: "Calm & gentle approach", icon: "sun", desc: "A quiet, considered space designed to ease nerves and make every visit feel easy." },
    { id: "convenient", name: "Convenient appointments", icon: "circle", desc: "Evening and weekend availability for busy schedules across the area." },
  ],
};

const MOCK_TESTIMONIALS = {
  items: [
    { name: "Aanya K.", role: "Mohali", quote: "Got my smile makeover done here — the veneers are absolutely perfect. The dentist has an incredible eye for detail.", rating: 5 },
    { name: "Rohit S.", role: "Chandigarh", quote: "Painless root canal and crown in two visits. The whole clinic feels like a luxury spa. Worth every rupee.", rating: 5 },
    { name: "Simran B.", role: "Mohali", quote: "My Invisalign journey was so well guided. The monthly check-ins kept me motivated and on track.", rating: 5 },
    { name: "Devansh M.", role: "Panchkula", quote: "Whitening results were incredible — lifted 6 shades in one sitting. The clinic is immaculate and the team is so warm.", rating: 5 },
  ],
};

export const createBooking = (data) =>
  api
    .post("/bookings", data)
    .then((r) => {
      if (typeof r.data === "string" && r.data.trim().startsWith("<!doctype")) {
        throw new Error("HTML returned instead of JSON");
      }
      return r.data;
    })
    .catch((err) => {
      console.warn("Backend unavailable, simulating booking locally:", err);
      return { ok: true, message: "Booking received. Our team will reach out shortly. (Local Simulation)" };
    });

export const fetchServices = () =>
  api
    .get("/services")
    .then((r) => {
      if (typeof r.data === "string" && r.data.trim().startsWith("<!doctype")) {
        throw new Error("HTML returned instead of JSON");
      }
      if (!r.data || !r.data.dental) {
        throw new Error("Invalid response format");
      }
      return r.data;
    })
    .catch((err) => {
      console.warn("Backend unavailable, using static fallback services:", err);
      return MOCK_SERVICES;
    });

export const fetchTestimonials = () =>
  api
    .get("/testimonials")
    .then((r) => {
      if (typeof r.data === "string" && r.data.trim().startsWith("<!doctype")) {
        throw new Error("HTML returned instead of JSON");
      }
      if (!r.data || !r.data.items) {
        throw new Error("Invalid response format");
      }
      return r.data;
    })
    .catch((err) => {
      console.warn("Backend unavailable, using static fallback testimonials:", err);
      return MOCK_TESTIMONIALS;
    });


